import api from ".";
import cookiesModifier from "../utils/cookies";

import { IParameter } from "../types/parameter";

export const createParameter = async (data: IParameter) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`parameters`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateParameter = async (data: IParameter) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`parameters/${data.id}`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteParameter = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`parameters/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}